"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubscriptionModuleMode = void 0;
let SubscriptionModuleMode = exports.SubscriptionModuleMode = /*#__PURE__*/function (SubscriptionModuleMode) {
  SubscriptionModuleMode["Subscribe"] = "subscribe";
  SubscriptionModuleMode["Purchase"] = "purchase";
  return SubscriptionModuleMode;
}({});
//# sourceMappingURL=types.js.map